import React from 'react';

import { PageContainerRow, PageGroupIconContainer, PageGroupTitleContainer } from './GeneralPageGroup.styles';

interface TitleIconRowProps {
  icon: JSX.Element;
  title: string;
  open: boolean;
  $isExpanded?: boolean;
  $isActive?: boolean;
}

export const TitleIconRow = ({ icon, title, open, $isExpanded, $isActive }: TitleIconRowProps) => {
  return (
    <PageContainerRow open={open}>
      <PageGroupIconContainer>{icon}</PageGroupIconContainer>
      <PageGroupTitleContainer open={open} $isActive={$isActive} $isExpanded={$isExpanded}>
        {title}
      </PageGroupTitleContainer>
    </PageContainerRow>
  );
};
